import React from 'react';
import FormInputs from './FormInputs';
import Image from '../../../atoms/Image';
import WithBackgroundImage from '../../../darkmatter/WithBackgroundImage/WithBackgroundImage';
import { EmailCaptureImagePropType, EmailCaptureTypePropType } from '../EmailCapture.propTypes';
import closebtnImg from '../assets/closebtn.png';
import closebtnDarkImg from '../assets/closebtnDark.png';
var defaultProps = {
  image: null,
  darkCloseBtn: true
};
export default function Form(props) {
  var closeEmailCapture = props.closeEmailCapture,
    type = props.type,
    image = props.image,
    darkCloseBtn = props.darkCloseBtn;
  var displayCloseBtn = type !== 'inline';
  if (image && image.url) {
    if (image.placement === 'background') {
      return /*#__PURE__*/React.createElement(WithBackgroundImage, {
        image: image.url
      }, /*#__PURE__*/React.createElement(FormInputs, props));
    }
    if (image.placement === 'left') {
      return /*#__PURE__*/React.createElement("div", {
        className: "emailcapture-withimage-horizontal"
      }, /*#__PURE__*/React.createElement(WithBackgroundImage, {
        image: image.url
      }, /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement(FormInputs, props));
    }
    if (image.placement === 'right') {
      return /*#__PURE__*/React.createElement("div", {
        className: "emailcapture-withimage-horizontal"
      }, /*#__PURE__*/React.createElement(FormInputs, props), /*#__PURE__*/React.createElement(WithBackgroundImage, {
        image: image.url
      }, /*#__PURE__*/React.createElement("div", null, displayCloseBtn && /*#__PURE__*/React.createElement(Image, {
        as: "a",
        id: "closeEmailCapture",
        src: darkCloseBtn ? closebtnDarkImg : closebtnImg,
        onClick: function onClick() {
          return closeEmailCapture(true);
        }
      }))));
    }
    if (image.placement === 'top') {
      return /*#__PURE__*/React.createElement("div", {
        className: "emailcapture-withimage-vertical"
      }, /*#__PURE__*/React.createElement(WithBackgroundImage, {
        image: image.url
      }, /*#__PURE__*/React.createElement("div", null, displayCloseBtn && /*#__PURE__*/React.createElement(Image, {
        as: "a",
        id: "closeEmailCapture",
        src: darkCloseBtn ? closebtnDarkImg : closebtnImg,
        onClick: function onClick() {
          return closeEmailCapture(true);
        }
      }))), /*#__PURE__*/React.createElement(FormInputs, props));
    }
  }
  return /*#__PURE__*/React.createElement(FormInputs, props);
}
Form.defaultProps = defaultProps;